<template>
  <div class="layer-settting" :style="{left: active ? 0 : '100%'}">
    <draggable
      v-model="list"
      tag="ul"
      v-bind="dragOptions"
      @start="drag = true"
      @end="dragEnd"
    >
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <li class="list-group-item" v-for="s, i in list" :key="s.id" @mouseenter="doHandle(s, true)" @mouseleave="doHandle(s,false)">
          <div class="item-type-pic">
            <div v-if="s.type === 'Text' || s.type === 'RichText'" class="textIcon" @click="selectSprite(s)"></div>
            <div v-else @click="selectSprite(s)" v-html="s.getThumbnail().children().css({
              position: 'inherit',
              width: '',
              height: '',
              maxWidth: '100%',
              maxHeight: '100%',
              transform: 'none'
            }).prop('outerHTML')"></div>
            <span>{{s.type | getText(s.text)}}</span>
          </div>
          <div class="item-icon-btn">
            <i class="icon" :class="[s.locked ? 'icon-set-lock' :'icon-set-unlock']" @click="iconClick('lock', s, i)"></i>
            <i class="icon icon-set-delete" @click="iconClick('delete', s, i)"></i>
          </div>
        </li>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from "vuedraggable";

export default {
  props: {
    active: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      list: [],
      drag: false,
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
    ]),
    dragOptions () {
      return  {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
  },
  watch: {
    'SelectScenes_Msg.id': function() {
      this.initData()
    },
    'SelectScenes_Msg.sprites': function() {
      this.initData()
    },
    'active': function() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
    eve.on('sceneSprite.unLoadData.fromJsonLoadingState', (data) => {
      if(data.state === 2) this.initData();
    })
    this.$bus.on("undoRedoHandle", this._undoRedoHandle);
  },
  methods: {
    initData() {
      if(!this.SelectScenes_Msg || !this.active) return;
      let sprites = this.SelectScenes_Msg.sprites,
          list = [];
      for(let i = sprites.length - 1; i >= 0 ; i--) {
        list.push(sprites[i]);
      }
      this.list = list;
    },
    dragEnd() {
      // 可以优化
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        reData: [],
        data: []
      }
      this.drag = false;
      let len = this.list.length - 1;
      for(let i = 0; i <= len; i++) {
        undoData.reData.push({
          id: this.list[i].id,
          index: this.list[i].index,
        })
        this.list[i].zIndex = len - i;
        this.list[i].setIndex(len - i);
        undoData.data.push({
          id: this.list[i].id,
          index: len - i,
        })
      }
      this.SelectScenes_Msg.sprites.sort(function (a, b) {
        return a.zIndex - b.zIndex;
      });
      eve("undo_redo", null, {type: 'layerSetting', data: undoData})
    },
    iconClick(type, s, i) {
      if(type === 'lock') {
        s.setLocked(!s.locked);
        s.opHelper.lockDom.css('display', s.locked ? '' : 'none')
      } else if(type === 'delete') {
        this.TOOL.removeSprite(s.id, true);
        this.initData();
      }
    },
    doHandle(s, bol) {
      // 代码有点糙，但是不想在引擎代码中加
      s.showHideHandle(bol);
      s.opHelper.handlePointEle.hide()
    },
    selectSprite(s) {
      this.$bus.emit("spritesFlagTime", {
        enterTime: s.effect.entranceAnim.end,
        exitTime: s.effect.exitAnim.start
      })
      this.TOOL.selectSprite([s]);
    },
    _undoRedoHandle ({type}) {
      if (type === 'layerSetting') {
        this.initData();
      }
    }
  },
  components: {
    draggable,
  },
  beforeDestroy () {
    eve.off('sceneSprite.unLoadData.fromJsonLoadingState');
    this.$bus.off("undoRedoHandle", this._undoRedoHandle)
  },
  filters: {
    getText(type, text) {
      let s = '';
      switch (type) {
        case "Text":
          s = text;
          break;
        case "Image":
          s = "图片";
          break;
        case "Lottie":
          s = "矢量动图";
          break;
        case "Svg":
          s = "svg";
          break;
        case "Gif":
          s = "gif";
          break;
        case "Frame":
          s = "相框";
          break;
        case "Video":
          s = "视频";
          break;
        case "RichText":
          s = text;
          break;
        case "Chart":
          s = "图表";
          break;
      }
      return s;
    }
  }
}
</script>

<style lang="scss" scoped>
.layer-settting {
  position: absolute;
  top: 0;
  left: 100%;
  width: 226px;
  transition: all 0.3s;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  width: 100%;
  line-height: 40px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;

  .item-type-pic {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 165px;
    height: 40px;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      overflow: hidden;
      background-color: #d4d6e6;
      cursor: pointer;
    }

    div.textIcon {
      background-image: url("../../../static/svg/materialPane/navBtns/text.svg");
      background-size: 60%;
      background-position: 55% 50%;
      background-repeat: no-repeat;
    }

    span {
      display: block;
      width: 100px;
      margin-left: 5px;
      text-align: left;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }

  .item-icon-btn {
    display: flex;
    width: 55px;
    justify-content: space-between;
    align-items: center;
  }

  // &:hover {
  //   background: #F0F0F8;
  // }
}
.list-group-item i {
  margin-left: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/settingPanel/layerSetting.vue